import React from 'react'

function TermsOfService() {
  return (
    <><div className="mb-5"><p><strong>Terms of Service for DibruGo</strong></p>

<p><strong>Effective Date:</strong> [Insert Date]</p>

<p>Welcome to DibruGo ("we," "our," or "us"). By accessing or using our website https://dibrugo.com and our services, you agree to comply with and be bound by these Terms of Service.</p>

<p><strong>1. Services</strong></p>
<p>DibruGo provides taxi booking and self-drive vehicle services. We act as a platform connecting customers with drivers and vehicle providers.</p>

<p><strong>2. User Responsibilities</strong></p>
<p>You agree to provide accurate and complete information while booking a ride. You must use our services only for lawful purposes and behave respectfully with drivers and staff.</p>

<p><strong>3. Booking and Payments</strong></p>
<p>All bookings are subject to availability. Prices may vary based on distance, time, and demand. Payments must be made through approved payment methods or as agreed during booking.</p>

<p><strong>4. Cancellation and Refunds</strong></p>
<p>Cancellation policies may vary depending on the type of service booked. Refunds, if applicable, will be processed within a reasonable time.</p>

<p><strong>5. User Conduct</strong></p>
<p>You must not misuse the service, engage in fraudulent activity, or cause harm to drivers, vehicles, or the platform. We reserve the right to suspend or terminate accounts violating these terms.</p>

<p><strong>6. Limitation of Liability</strong></p>
<p>DibruGo is not liable for delays, accidents, or any damages arising from the use of our services. We do not guarantee uninterrupted or error-free service.</p>

<p><strong>7. Third-Party Services</strong></p>
<p>Our platform may involve third-party providers such as drivers or payment gateways. We are not responsible for their actions or services.</p>

<p><strong>8. Intellectual Property</strong></p>
<p>All content on this website, including logos, text, and design, is the property of DibruGo and must not be used without permission.</p>

<p><strong>9. Termination</strong></p>
<p>We reserve the right to terminate or suspend access to our services at our discretion without prior notice.</p>

<p><strong>10. Changes to Terms</strong></p>
<p>We may update these Terms of Service at any time. Continued use of the website means you accept the updated terms.</p>

<p><strong>11. Governing Law</strong></p>
<p>These terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of local courts.</p>

<p><strong>12. Contact Us</strong></p>
<p>Business Name: DibruGo</p>
<p>Website: https://dibrugo.com</p>
<p>Email: support@dibrugo.com</p>
<p>Phone: [Insert Phone Number]</p>

<p>By using our services, you agree to these Terms of Service.</p></div></>
  )
}

export default TermsOfService